export const footernav = [
    {
        title: 'SERVICES',
        navs : ['Department of Computer Science','Business Administration']
    },
    {
        title: 'INFORMATION',
        navs : ['Eligibility Criteria','Scholarship Policy','Admission Policy','Fee structure','Apply Online']
    },
    {
        title: 'LEGAL',
        navs: ['Semester Rules','Academic Calender','Academic Linkages']
    },
    {
        title: 'GET IN TOUCH',
        navs: ['info@emaan.edu.pk','hr@emaan.edu.pk','Hiring Statistics','Plot # A-2, Sector 28 Suparco Rd, Gulzar-E-Hijri Scheme 33, Karachi, Pakistan.']
    }
]